export const tieredProviderLocations = (providerLocations): string[] =>
  providerLocations?.filter((location) => location?.isTieredProvider === true);

export const acoProviderLocations = (providerLocations): string[] =>
  providerLocations?.filter(
    (location) => Array.isArray(location?.acoProvider) && location?.acoProvider.length > 0
  );
export const getAddress = (address: any): string => {
  const addressLine = address?.line?.[0] ?? '';
  const city = address?.city ?? '';
  const state = address?.state ?? '';

  return [addressLine, city, state].filter(Boolean).join(', ');
};
export const defaultBooleanToFalse = (bool?: boolean | null): boolean => bool ?? false;
export type Maybe<T> = T | null | undefined;